import { getSpaceLink } from '@confluence/route-manager-utils/entry-points/url.ts';
import { isCompanyHubSpaceKey } from '@confluence/route-manager/entry-points/companyHubUtils.ts';
import {
	HOME,
	SPACE_OVERVIEW,
	COMPANY_HUB,
	FOLDER_VIEW,
} from '@confluence/named-routes/entry-points/routes.ts';

import type { BreadcrumbsType } from '../hooks/useEditorBreadcrumbs/useEditorBreadcrumbs.ts';

import { getNearestVisibleAncestor } from './getNearestVisibleAncestor.ts';

export const getPublishPreloadUrl = ({
	contentId,
	spaceKey,
	contentType,
}: {
	contentId: string;
	spaceKey: string;
	contentType: string;
}): string => {
	if (isCompanyHubSpaceKey(spaceKey)) {
		return COMPANY_HUB.toUrl();
	}

	const path = `${getSpaceLink(spaceKey, contentType === 'page' ? 'pages' : 'blog')}/${contentId}`;
	return path;
};

export const getClosePreloadUrl = ({
	contentId,
	spaceKey,
	contentType,
	breadcrumbs,
	isUnpublishedDraft,
}: {
	contentId: string;
	spaceKey: string;
	contentType: string;
	breadcrumbs: BreadcrumbsType;
	isUnpublishedDraft: boolean;
}): string => {
	let url = HOME.toUrl();
	if (isUnpublishedDraft) {
		if (contentType === 'page') {
			// Draft page -> redirect to closest published parent view page
			if (breadcrumbs) {
				url = getNearestVisibleAncestor({
					breadcrumbs,
					fallbackUrl: url,
				});
				// if the parent is a folder, redirect to the space overview
				if (FOLDER_VIEW.match(url)) {
					url = SPACE_OVERVIEW.toUrl({ spaceKey });
				}
			}
		} else {
			// Draft blog -> redirect to space index page
			url = SPACE_OVERVIEW.toUrl({ spaceKey });
		}
	} else {
		// this part executes when closing the edit section for a previously/already published page
		// we can do a lil hack here to avoid making a query.
		// the router will prettify our route with slug (& posting date for blogs) for us
		url = getPublishPreloadUrl({ contentId, spaceKey, contentType });
	}

	return url;
};
